export const texts = {
  positionsLink: {
    de: 'Stellen',
    en: 'Positions'
  },
  genderSuffix: {
    de: 'm|w|d',
    en: 'm|f|d'
  },
  oneMore: {
    de: '+ 1 weiterer',
    en: '+ 1 more'
  },
  moreSuffix: {
    de: 'weitere',
    en: 'more'
  },
  remoteUpTo: {
    de: 'Remote bis',
    en: 'Remote up to'
  },
  permanent: {
    de: 'Unbefristet',
    en: 'Permanent'
  },
  fixedTerm: {
    de: 'Befristet',
    en: 'Fixed-term'
  },
  freelancer: {
    de: 'Freelancer',
    en: 'Freelancer'
  },
  fullTime: {
    de: 'Vollzeit',
    en: 'Full-time'
  },
  partTime: {
    de: 'Teilzeit',
    en: 'Part-time'
  },
  partOrFullTime: {
    de: 'Teilzeit/Vollzeit',
    en: 'Part-time/Full-time'
  },
  modal: {
    title: {
      de: 'Basisdaten bearbeiten',
      en: 'Edit basic data'
    },
    jobTitle: {
      de: 'Stellentitel',
      en: 'Job title'
    },
    locations: {
      de: 'Arbeitsorte',
      en: 'Locations'
    },
    salary: {
      de: 'Gehalt',
      en: 'Salary'
    },
    to: {
      de: 'bis',
      en: 'to'
    },
    remoteShare: {
      de: 'Remoteanteil',
      en: 'Remote share'
    },
    employmentType: {
      de: 'Anstellungsart',
      en: 'Employment type'
    },
    employmentPermanent: {
      de: 'Festanstellung',
      en: 'Permanent employment'
    },
    employmentInterim: {
      de: 'Befristete Anstellung',
      en: 'Fixed-term employment'
    },
    employmentFreelancer: {
      de: 'Freelancer',
      en: 'Freelancer'
    },
    employmentSelfEmployed: {
      de: 'Selbstständigkeit',
      en: 'Self-employment'
    },
    employmentInternship: {
      de: 'Praktikum',
      en: 'Internship'
    },
    fullTimeLabel: {
      de: 'Vollzeit',
      en: 'Full-time'
    },
    partTimeLabel: {
      de: 'Teilzeit',
      en: 'Part-time'
    },
    yes: {
      de: 'Ja',
      en: 'Yes'
    },
    no: {
      de: 'Nein',
      en: 'No'
    },
    done: {
      de: 'Fertig',
      en: 'Done'
    }
  },
  viewJobsite: {
    de: 'Jobsite ansehen',
    en: 'View jobsite'
  },
  progress: {
    analysis: { de: 'Analyse', en: 'Analysis' },
    talents: { de: 'Talente', en: 'Talents' },
    outreach: { de: 'Ansprache', en: 'Outreach' },
    applications: { de: 'Bewerbungen', en: 'Applications' }
  },
  startSourcing: {
    de: 'Sourcing starten',
    en: 'Start sourcing'
  },
  bookConsultation: {
    de: 'Kostenlose Beratung buchen',
    en: 'Book a free consultation'
  }
};
